export class TimeoutError extends Error {}

export default function postMessageWithResponse<T>(
  parseResponseData: (data: unknown) => T | undefined,
  timeoutMs: number,
  msg: any,
): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const timer = setTimeout(() => {
      window.removeEventListener('message', onMessage);
      reject(new TimeoutError());
    }, timeoutMs);

    const onMessage = (event: MessageEvent) => {
      if (event.source !== window) {
        return;
      }
      let parsed: T | undefined;
      try {
        parsed = parseResponseData(event.data);
      } catch (e) {
        clearTimeout(timer);
        window.removeEventListener('message', onMessage);
        throw e;
      }
      if (parsed === undefined) {
        return;
      }
      clearTimeout(timer);
      window.removeEventListener('message', onMessage);
      resolve(parsed);
    };

    window.addEventListener('message', onMessage);
    window.postMessage(msg);
  });
}
